fnResize();
window.onresize = function () {
  fnResize();
}
function fnResize() {
  var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
  deviceWidth = deviceWidth>1600?1600:deviceWidth
  document.documentElement.style.fontSize = (deviceWidth / 10) + 'px';
}